class ContactData {
    name: string = "";
    email: string = "";
    subject: string = "";
    question: string = "";
}

export default ContactData;;